import React, { Component } from "react";
import { Modal, Form, Col, Button, Card, Container, Row, Table } from "react-bootstrap";
import moment from "moment";
import { withRouter } from "react-router-dom";
import * as compose from "lodash.flowright";
import gql from "graphql-tag";
import { withApollo } from "react-apollo";
import { graphql } from "react-apollo";
import "./_leadManagement.scss"

class FollowupHistoryModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            followUpData: [],
            dataClear: 1,
            loadingSpinner: 0,
            is_submitted: false,
            employee_name: this.props.stateData?.employee_name
        }
    }


    // getLeadFollowUpDetails = async (val) => {
    //     this.setState({ loadingSpinner: 1 })

    //     const result = await this.props.client.query({
    //         query: gql`
    //         query($lead_id: Int!) {
    //             getLeadFollowUpDetails(lead_id: $lead_id) {
    //                 lead_id
    //                 lead_name
    //                 lead_mobile
    //                 status_id
    //                 source_name
    //                 source_name
    //                 followUp_History {
    //                   comments
    //                   employee_id
    //                   employee_name
    //                   todayfollowUpDate
    //                   nextFollowUpDate
    //                   calling_status
    //                }
    //             }
    //           }
    //         `,
    //         variables: {
    //             lead_id: parseInt(val),
    //         },
    //         fetchPolicy: 'network-only'
    //     })

    //     if (result.data.getLeadFollowUpDetails.length > 0) {
    //         let data = result.data.getLeadFollowUpDetails[0].followUp_History;
    //         console.log("datae0", data);
    //         this.setState({ followUpData: data, loadingSpinner: 0, is_submitted: true })
    //     } else {
    //         this.setState({ followUpData: [], loadingSpinner: 0, is_submitted: true })
    //     }
    // }


    // componentDidUpdate() {

    //     if (this.props.show === true && this.state.dataClear == 0) {
    //         this.getLeadFollowUpDetails(this.props.stateData.lead_id)
    //         this.setState({
    //             dataClear: 1
    //         })
    //     }
    //     if (this.props.show === false && this.state.dataClear == 1) {
    //         this.setState({ dataClear: 0, followUpData: [], is_submitted: false })
    //     }
    // }

    // getCallingStatusBackgroundColor = (callingStatus) => {
    //     const backgroundColors = {
    //         'Connected': 'green',
    //         'Dead Cal': 'red',
    //         'Disconnected': 'gray',
    //         'Follow Up Required': 'orange',
    //         'Not interested': 'purple',
    //         'Not reachable': 'brown',
    //         'Switch Off': 'black',
    //         'Unanswered': 'blue',
    //         'Wrong number': 'pink',
    //         'Call back required': '#186F65'
    //     };

    //     return backgroundColors[callingStatus] || 'white';
    // };



    render() {

        console.log("ppprrrrrrrrrrors", this.props.stateData);


        return (
            <Modal
                {...this.props}
                size="sm"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton style={{ backgroundColor:"#213046"}}>
                    <Modal.Title>History</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-4">
                    <div style={{
                        width: '100%',
                        height: '200px',
                        overflowY: 'auto',
                        overflowX: 'hidden'
                    }}>
                            {/* <h6> History of <span> {this.props.stateData?.rowData?.lead_name} </span></h6> */}
                        {
                            this.props.stateData?.rowData?.history?.length > 0 ? (

                                this.props.stateData?.rowData?.history?.map((item, index) => {
                                    let todayfollowUpDate = moment.unix(item.inserted_time).format("DD MMM YYYY h:mm a");
                                    // let followupDate = moment.unix(item.nextFollowUpDate).format("DD MMM YYYY h:mm a");
                                    return (
                                        <div className="mb-2">
                                                    <Row>
                                                        <Col sm={12} md={12} lg={12}>
                                                            <p className="text-muted" style={{ fontSize: "12px", fontFamily: "Helvetica", fontWeight: "600", }}>followup Update at {todayfollowUpDate} </p>
                                                        </Col>
                                                        {/* <Col sm={4} md={4} lg={4}>
                                                            <p className="text-center" style={{ color: "#000000", padding: "3px 5px", borderRadius: '19px', backgroundColor: '#dee2e6' }}>{item.calling_status}</p>
                                                        </Col> */}
                                                    </Row>
                                                    <Row>
                                                        <Col sm={12}>
                                                            <Card className="border-0">
                                                                <Card.Body>
                                                                    {item.comments || '-'}
                                                                </Card.Body>
                                                            </Card>
                                                        </Col>
                                                    </Row>

                                                    <hr />
                                                </div>

                                    )
                                })
                            ) : (
                                    <div className="mt-2 d-flex justify-content-center align-items-center">
                                        <p>No History Available</p>
                                    </div>
                                ) 
                        }
                    </div>
                </Modal.Body>
            </Modal>
        )
    }
}


export default withRouter(withApollo(compose(
)(FollowupHistoryModal)));

